const ROUTE_VIEW_INFORMATION = [
  // 健康资讯
  { path: '/information', name: '资讯', h5Uri: '/information/information', nativeUri: null, whiteList: true },
  { path: '/informationContent', name: '资讯内容', h5Uri: '/information/information_content', nativeUri: null, whiteList: true }
]
export default ROUTE_VIEW_INFORMATION



// WEBPACK FOOTER //
// ./src/router/mapping/information.js